import { Seo } from '../components/Seo';
import { FaqBlock } from '../components/FaqBlock';
import { PAGES } from '../lib/config';
import { FAQ_PAGE_ITEMS } from '../lib/content';
import {
  softwareApplicationSchema,
  faqSchema,
  breadcrumbsSchema,
  websiteSchema,
  organizationSchema,
} from '../lib/schema';

const page = PAGES.find((p) => p.path === '/faq')!;

export function FaqPage() {
  return (
    <>
      <Seo
        page={page}
        schemas={[
          websiteSchema(),
          organizationSchema(),
          softwareApplicationSchema(),
          faqSchema(FAQ_PAGE_ITEMS),
          breadcrumbsSchema(page),
        ]}
      />
      <section className="bg-gradient-to-b from-primary-50/10 to-bg-base px-4 py-12 text-center sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-3xl font-extrabold tracking-tight text-text-primary sm:text-4xl">
            {page.h1}
          </h1>
          <p className="mt-3 text-lg text-text-secondary">{page.subhead}</p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <FaqBlock items={FAQ_PAGE_ITEMS} />
      </section>
    </>
  );
}
